import { EntityRepository } from "../";
import { Account } from "../domain";

class AccountRepository implements EntityRepository<Account> {
  private _repo: EntityRepository<Account>;

  constructor(repo:EntityRepository<Account>) {
    this._repo = repo;
  }
  checkUniqueString(attribute: (obj: Account) => string, value: string): boolean {
    return this._repo.checkUniqueString(attribute, value);
  }

  getAll(): Account[] {
    return this._repo.getAll();
  }
  get(uuid: string): Account | undefined {
    return this._repo.get(uuid);
  }
  put(uuid: string, value: Account): Promise<void> {
    return this._repo.put(uuid, value);
  }
  async putAll(values: Account[]) {
    return this._repo.putAll(values);
  }
  delete(uuid: string): void {
    if (this.checkIfParent(this.get(uuid))) {
      throw new Error("Delete failed, Parent dependency");
    }
    this._repo.delete(uuid);
  }

  checkIfParent(account?: Account) : boolean {
    if (!account) {
      return false;
    }
    return this.getAll()
      .filter(acc => acc.parent && acc.parent.uuid === account.uuid).length > 0
  }
}

export { AccountRepository };